function replaceElementWithIframe(element) {
    if (!element || !element.dataset.video) {
        return;
    }

    const url = element.dataset.video,
        parent = element.parentElement,
        frame = document.createElement('iframe');

    frame.classList.add('lazyLoadedIframe');
    frame.src = url;
    frame.width = element.width;
    frame.height = element.height;
    frame.setAttribute('allow', 'autoplay');
    frame.setAttribute('allowfrullscreen', true);

    if (element.dataset.iframetitle) {
        frame.setAttribute('title', element.dataset.iframetitle);
    }

    parent.appendChild(frame);
    parent.removeChild(element);
}

export default function lazyLoadVideo() {
    document.addEventListener('click', e => {
        if (e.target.dataset.video) {
            e.preventDefault();
            replaceElementWithIframe(e.target);
        }
    });
}
